import React from 'react';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import DailyTaskPlanner from '../components/dashboard/DailyTaskPlanner';

export default function DailyTasks() {
  const { data: user } = useQuery({
    queryKey: ['me'],
    queryFn: () => base44.auth.me()
  });

  const { data: profile } = useQuery({
    queryKey: ['myProfile'],
    queryFn: async () => {
      const profiles = await base44.entities.OfficerProfile.list();
      return profiles.find((p) => p.user_email === user?.email);
    },
    enabled: !!user
  });

  const isCommander = user?.role === 'admin' || profile?.custom_role === 'Commander';

  return (
    <div className="min-h-screen bg-slate-50 -m-8 p-8 pr-12">
      <div className="mb-6">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-2">
          Daily Tasks
        </h1>
        <p className="text-slate-600">
          Plan and track your daily tasks to advance key results.
        </p>
      </div>

      <DailyTaskPlanner user={user} isCommander={isCommander} />
    </div>
  );
}